export default [
    {
        path: '/heishop/products',
        name: 'heishop-products',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/Products.vue')
    },

]